document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-prologo-facets-section]').forEach((section) => {
    const drawer = section.querySelector('[data-prologo-facets-drawer]');
    const openBtn = section.querySelector('[data-prologo-facets-open]');
    const closeBtn = section.querySelector('[data-prologo-facets-close]');
    const backdrop = section.querySelector('[data-prologo-facets-backdrop]');

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    };

    const openDrawer = () => {
      if (!drawer) return;
      drawer.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    };

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    section.querySelectorAll('.prologo-facets__popover').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        section.querySelectorAll('.prologo-facets__popover[open]').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDrawer();
        section.querySelectorAll('.prologo-facets__popover[open]').forEach((el) => el.removeAttribute('open'));
      }
    });

    document.addEventListener('click', (event) => {
      if (!section.contains(event.target)) {
        section.querySelectorAll('.prologo-facets__popover[open]').forEach((el) => el.removeAttribute('open'));
      }
    });
  });
});
